import 'symbol-observable'; // Must be first to prevent Redux DevTools warning
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { register as registerServiceWorker } from './serviceWorkerRegistration';
import { Provider } from "react-redux";
import store, { persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import ErrorBoundary from './components/ErrorBoundary';
import { fetchDomainDataThunk } from './store/thunks/mdsThunks';
// import theme from "./theme/theme"; // ❌ Remove this
import { ThemeProvider } from "@mui/material/styles"; // ❌ Remove this
import KeycloakWrapper from './KeycloakWrapper';
import Loader from "./components/common/custom-component/Loader";
import basicTheme from "./theme/basicTheme";
import { setDomainData } from './store/slices/database/domainConfigSlice';

console.log('🎬 index.js executed');
// 🔐 Add this BEFORE anything else initializes
// Add this at the top of index.js, before React renders
/* window.addEventListener("message", (event) => {
	// 1️⃣ Only accept messages from the same origin
	//if (event.origin !== window.location.origin) return;

	// 2️⃣ Only handle messages that are objects with type === "KEYCLOAK_SILENT_SSO"
	if (!event.data || event.data.type !== "KEYCLOAK_SILENT_SSO") return;

	// ✅ At this point we know it's our Keycloak message
	console.log("🔑 Keycloak silent SSO message received:", event.data);

	// 3️⃣ Do something once, e.g., reload the parent window
	window.location.reload();
}); */


const root = ReactDOM.createRoot(document.getElementById('root'));

function AppInitializer() {

	const [domainConfig, setDomainConfig] = React.useState(null);
	const [loading, setLoading] = React.useState(true);
	const [error, setError] = React.useState(null);

	React.useEffect(() => {
		async function initializeApp() {
			try {
				console.log('🔧 Fetching domain data...');

				const response = await store.dispatch(fetchDomainDataThunk({
					domainName: window.location.hostname
				}));

				if (fetchDomainDataThunk.rejected.match(response)) {
					throw new Error(response.payload || 'Failed to fetch domain data');
				}

				const domainData = response.payload?.data;
				console.log('✅ Domain data loaded:', domainData);
				store.dispatch(setDomainData(domainData))
				setDomainConfig(domainData);
				setLoading(false);

			} catch (err) {
				console.error('❌ Failed to initialize app:', err);
				setError(err.message);
				setLoading(false);
			}
		}

		initializeApp();

	}, []);

	if (loading && window.self === window.top) {
		return (
			<div style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh'
			}}>
				<Loader variant="circular" message="Loading configuration..." size="small" />
			</div>
		);
	} /* else if (loading && window.self !== window.top) {
		window.parent.location.reload()
	} */

	if (error) {
		return (
			<div style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh',
				flexDirection: 'column',
				color: 'red'
			}}>
				<h2>Failed to load configuration</h2>
				<p>{error}</p>
				<button onClick={() => window.location.reload()}>Retry</button>
			</div>
		);
	}
	if (!loading) {
		return (
			<KeycloakWrapper domainConfig={domainConfig}>
				<App domainConfig={domainConfig} />
			</KeycloakWrapper>
		);
	}
	/* return (
		<KeycloakWrapper domainConfig={domainConfig}>
			<App domainConfig={domainConfig} />
		</KeycloakWrapper>
	); */
}

// ✅ No ThemeProvider here anymore
root.render(
	<ThemeProvider theme={basicTheme}>
		<ErrorBoundary>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<AppInitializer />
				</PersistGate>
			</Provider>
		</ErrorBoundary>
	</ThemeProvider>

);

reportWebVitals();
registerServiceWorker();